import { useQuery } from '@tanstack/react-query';

export interface IPTrackingAlert {
  content_type: 'topic' | 'post';
  content_id: string;
  title: string;
  created_at: string;
  author_name: string;
  category_name: string;
}

export const useIPTrackingAlerts = () => {
  return useQuery({
    queryKey: ['ip-tracking-alerts'],
    queryFn: async (): Promise<IPTrackingAlert[]> => {
      // IP tracking feature disabled - tables not available
      return [];
    },
    enabled: false, // Disable query
    refetchInterval: 30000,
  });
};
